export const appConfig = {
  github: {
    perPage: 1000,
    initialPage: 1,
  },
  pageCount: 6,
};
